var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeStarBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99325 1.33334C4.31325 1.33334 1.33325 4.32001 1.33325 8.00001C1.33325 11.68 4.31325 14.6667 7.99325 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00001C14.6666 4.32001 11.6799 1.33334 7.99325 1.33334ZM10.1466 11.5933L7.99992 10.3L5.85325 11.5933C5.59992 11.7467 5.28659 11.52 5.35325 11.2333L5.91992 8.79334L4.03325 7.16001C3.81325 6.96668 3.93325 6.60001 4.22659 6.57334L6.71992 6.36001L7.69325 4.06001C7.80659 3.78668 8.19325 3.78668 8.30659 4.06001L9.27992 6.35334L11.7733 6.56668C12.0666 6.59334 12.1866 6.96001 11.9599 7.15334L10.0733 8.78668L10.6399 11.2333C10.7066 11.52 10.3999 11.7467 10.1466 11.5933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeStarBg);
export default __webpack_public_path__ + "static/media/upgrade-star-bg.8df03cec17339bf4c9ba33f92d209d82.svg";
export { ForwardRef as ReactComponent };